define(['jquery'],
    function($) {
        function copy_field(e) {
            e.preventDefault();
            let button = $(e.target);
            let input = button.closest('.form-row').find('input');
            input.focus();
            input.select();
            let successful = document.execCommand('copy');
            if(successful){
                button.text('Copied!');
                setTimeout(function () {
                    button.text('Copy');
                }, 1000);
            }
        }
        return {'init': function() {
            $('button').click(copy_field);
        }};

    }
);
